export default function getTopRow(contentState, tableId) {
  const blocks = contentState.getBlocksAsArray();
  let row = 0;
  for (const block of blocks) {
    if (block.get("type") === "Table" && block.getIn(["data", "tableId"]) === tableId && block.getIn(["data", "is_deleted"]) === false) {
      row = block.getIn(["data", "row"]);
    }
  }
  return row;
}